export interface NewUserRegistrationRequestModel {
  name: string;
  email: string;
  password: string;
}
